<template>
    <div>
        <NavComponent :index="3"></NavComponent>
        <SideBarComponent></SideBarComponent>
        <div class="procedure">
            <div class="main content-container">
                <div class="item" v-for="(item,index) in stepList" :key="index">
                    <div class="img" v-if="(index+1)%2 != 0">
                        <img :src="item.img" />
                    </div>
                    <div class="content">
                        <div class="step-title">{{item.title}}</div>
                        <div>
                            <div class="line"><span class="round"></span><p>{{item.p1}}</p></div>
                            <div class="line"><span class="round" style="background-color: #5da79d;"></span><p>{{item.p2}}</p></div>
                            <div class="line"><span class="round" style="background-color: #ef826e;"></span><p>{{item.p3}}</p></div>
                            <p v-if="item.p4">{{item.p4}}</p>
                            <p v-if="item.p5">{{item.p5}}</p>
                            <p v-if="item.p6">{{item.p6}}</p>
                        </div>
                    </div>
                    <div class="img" v-if="(index+1)%2 == 0">
                        <img :src="item.img" />
                    </div>
                </div>
            </div>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

import one_icon from '@assets/image/hosting/step-one-icon.jpg'
import two_icon from '@assets/image/hosting/step-two-icon.jpg'
import three_icon from '@assets/image/hosting/step-three-icon.jpg'
import four_icon from '@assets/image/hosting/step-four-icon.jpg'
import five_icon from '@assets/image/hosting/step-five-icon.jpg'
import six_icon from '@assets/image/hosting/step-six-icon.jpg'
import seven_icon from '@assets/image/hosting/step-seven-icon.jpg'
import eight_icon from '@assets/image/hosting/step-eight-icon.jpg'

export default {
    name: 'MoveHousePage',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {
            stepList:[
                {img:one_icon,title:'与开发商交接房产',p1:'租金代收：定期催收租客租金',p2:'押金登记注册：按规定帮助房东完成押金登记注册',p3:'定期报告：租金收支报告定期发给客户，房屋收益清晰明确',p4:'',p5:''},
                {img:two_icon,title:'家具安装及室内布置（二手房产对应增值装修）',p1:'家具采购：专业渠道采购家具，保质保量',p2:'家具运输：免费运输，免费搬运，安心又省心',p3:'家具安装/组装：现场组装和安装，垃圾旧物全回收',p4:'（维修处理：遗留维修问题整体检测处理）',p5:'（增值装修：房屋整体翻新，为增值助力）',p6:'（家具换新：破旧家具换新，一站到位）'},
                {img:three_icon,title:'租金评估及市场推广',p1:'市场评估：专业人员根据市场情况科学定价',p2:'定制策略：营销策略量身定制',p3:'广告营销：线上线下双向推广',p4:'',p5:''},
                {img:four_icon,title:'房产出租及租客核查',p1:'安排租客看房：及时安排潜在房客看房，促进成交',p2:'租客征信背景调查：对潜在租客的征信背景详细调查，排除隐患',p3:'合同起草及签署：专业法律团队起草合同，协助租客完成合同签署',p4:'',p5:''},
                {img:five_icon,title:'租金代收及押金登记注册',p1:'租金代收：定期催收租客租金',p2:'押金登记注册：按规定帮助房东完成押金登记注册',p3:'定期报告：租金收支报告定期发给客户，房屋收益清晰明确',p4:'',p5:''},
                {img:six_icon,title:'房产维护及租客管理',p1:'物业维护：物业费、地租费、水电气等代处理，基础设备定期检查',p2:'租客入住：房屋整体清洁，协助租客办理入住手续，整理房产状况交接清单',p3:'租客管理：专业的维修、清洁团队，保障租客租期内体验',p4:'退房和续租：房客退房后整体房屋检查及清洁/及时和房客完成续租手续',p5:''},
                {img:seven_icon,title:'报税申请及报税服务',p1:'税号申请：帮助房东申请UTR个人税号(Unique Taxpayer Reference)及NRL非居民房东税务豁免号(Non-Resident Landlord)',p2:'材料整理：整理报税相关材料(收入、支出材料)',p3:'年度报税：专业会计师处理每年一次的报税事宜',p4:'',p5:''},
                {img:eight_icon,title:'房产转售与再投资',p1:'法律服务：专业律师事务所，全权处理买卖过程法律手续',p2:'专业渠道：英国本土房地产资源丰富，房产快速出手',p3:'转卖再投资：根据客户需求，量身定制再投资策略',p4:'',p5:''},
            ]
        }
    },
    mounted(){

    },
    methods:{

    }

}
</script>
<style lang="scss" scoped>
.main{
    padding:3rem 0 4.5rem;
    .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 3rem;
        p{
            color: $font;
            font-size: 1rem;
            line-height: 1.6rem;
            margin-left: 0.6rem;
        }
    }
    .step-title{
        color: #0e2d57;
        font-weight: 700;
        font-size: 1.2rem;
        margin: 0.4rem auto 1.8rem;
    }
    .img{
        flex:0 0 auto;
    }
    .content{
        flex:0 0 auto;
        max-width: 34rem;
        .line{
            display: flex;
            align-items: center;
        }
        .round{
            display: inline-block;
            width: 0.35rem;
            height: 0.35rem;
            border-radius: 50%;
            margin-bottom: 0.2rem;
            flex:0 0 auto;
            background-color: #f1b85c;
        }
    }
}
@media only screen and (max-width: 1024px){
    .main{
        padding: 0rem 3% 2.4rem;
        .img{
            img{
                width: 10rem;
                height: auto;
            }
        }
        .content{
            max-width: 60%;
        }
    }
}
</style>